import { render, staticRenderFns } from "./MultiComponents.vue?vue&type=template&id=72929f91&scoped=true&"
import script from "./MultiComponents.vue?vue&type=script&lang=js&"
export * from "./MultiComponents.vue?vue&type=script&lang=js&"
import style0 from "./MultiComponents.vue?vue&type=style&index=0&id=72929f91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72929f91",
  null
  
)

export default component.exports